module.exports = __webpack_public_path__ + "img/CZ13584324.cff80d84.png";